
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/signup",
      function () {
        return require("private-next-pages/user/signup/index.js");
      }
    ]);
  